import type { ProceduresResponse } from 'features/Procedure/state/procedure-api.type'
import { memo } from 'react'
import { HistoricalProcedures } from '../../historical-procedures/historical-procedures'

type Props = {
  isFetching: boolean
  selectedPatientId: number | null
  selectedEncounterUid: string | null
  historicalData: ProceduresResponse['historical_procedures'] | undefined
}

export const TreatmentsHistoricalSection = memo(
  ({ isFetching, selectedPatientId, selectedEncounterUid, historicalData }: Props) => {
    return (
      <HistoricalProcedures
        historicalData={historicalData}
        selectedPatientId={selectedPatientId}
        selectedEncounterUid={selectedEncounterUid}
        isLoading={isFetching}
      />
    )
  },
)

TreatmentsHistoricalSection.displayName = 'TreatmentsHistoricalSection'
